import Container from '../../../../components/Container'
import { FormFinancialMovimentsTypesGroupss } from '../components/Form'
import { nameActions } from '../domain/info'
import { breadcrumbCreate } from '../domain/breadcrumb'
import { toolsCreate } from '../domain/tools/create'

const Create = (): JSX.Element => (
  <Container
    pageTitle={nameActions.create.name}
    breadcrumb={breadcrumbCreate}
    tools={toolsCreate}
  >
    <FormFinancialMovimentsTypesGroupss typeForm="create" />
  </Container>
)

export default Create
